module.exports = __webpack_public_path__ + "static/media/MovingApp_android_1_preview.cc595909.jpg";